import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
html {
  font-family:  ${(props) => props.theme.fonts.body};
  font-size: 10px;
  color: ${(props) => props.theme.colors.dark};
  transition: font-size 0.2s ease-in-out;
  scrollbar-gutter: stable;
}

html.modal-open, body.modal-open {
  overflow-y: hidden !important;
  height: 100%  !important;
  max-height: 100% !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {

  line-height: 1.3;
  font-family:  ${(props) => props.theme.fonts.title};
  font-weight: normal;
  b {
    font-weight: 600;
  }

}

body.ReactModal__Body--open,body.modal-open {
}

body {
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  padding: 0 !important;
  margin: 0 !important;
  left: 0;
    right: 0;
    bottom: 0;
    top: 0;

  font-size: 1.6rem;
}
  h1 {
  font-size: 2.8rem;
}
h2 {
  font-size: 2.6rem;
}
h3 {
  font-size: 2.4rem;
}
h4 {
  font-size: 1.8rem;
}
h4 {
  font-size: 1.6rem;
  font-weight: bold;
}
@media only screen and (min-width: 768px) {
  h1 {
  font-size: 3.2rem;
  }
  h2 {
    font-size: 2.8rem;
  }
  h3 {
    font-size: 2.5rem;
  }
  h4 {
    font-size: 2.2rem;
  }
  h4 {
    font-size: 1.8rem;
  }
}

.success {

    color: ${({ theme }) => theme.colors.green};
  }
  .error {

    color: ${({ theme }) => theme.colors.red};
  }



  /*
  1. Use a more-intuitive box-sizing model.
*/
*,
*::before,
*::after {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;

}
/*
  2. Remove default margin
*/
* {
  margin: 0;
}
/*
  Typographic tweaks!
  3. Add accessible line-height
  4. Improve text rendering
*/

/*
  5. Improve media defaults
*/
img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}
/*
  6. Remove built-in form typography styles
*/
input,
button,
textarea,
select {
  font: inherit;



  &:focus{
    outline-color: ${(props) => props.theme.colors.green} !important;
  }
}

/*
  7. Avoid text overflows
*/
p,
a,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}
/*
  8. Create a root stacking context
*/
#root,
#__next {
  isolation: isolate;
}

#root {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 100%;
  width: 100%;
  padding: 0;
}

.logo {
  height: 6em;
  will-change: filter;
  transition: filter 300ms;
}
.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}
.logo.react:hover {
  filter: drop-shadow(0 0 2em #61dafbaa);
}

@keyframes logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: no-preference) {
  a:nth-of-type(2) .logo {
    animation: logo-spin infinite 20s linear;
  }
}



.read-the-docs {
  color:${(props) => props.theme.colors.greyDarker};
}

:root {
  --accent: 136, 58, 234;
  --accent-light: 224, 204, 250;
  --accent-dark: 49, 10, 101;
  --accent-gradient: linear-gradient(
    45deg,
    rgb(var(--accent)),
    rgb(var(--accent-light)) 30%,
    white 60%
  );
}


h1,
h2,
h3,
h4,
h5,
h6 {
  color: ${(props) => props.theme.colors.blue};
  a{
    color: inherit;
    text-decoration: none;
    font-size: inherit;
    font-family: inherit;
  }
  &:hover {
     a {
       text-decoration: underline;
     }
  }
}

code {
  font-family: Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono,
    Bitstream Vera Sans Mono, Courier New, monospace;
}

.section {
  background-color: ${(props) => props.theme.colors.greyLight};
}


div,
p,
a,
li,
button {
  max-width: 100%;
}
button, a {
  cursor: pointer;
}
a {
    text-decoration: none;
}

.is-hidden{
  position: absolute;
  left: -9999999rem;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  clip-path: inset(50%);
  border: 0;
  padding: 0;
}

#root {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  z-index: 1;
}

.fade-out {
            opacity: 0;
            transition: opacity 0.5s ease-in-out;
          }

button, th {
  text-wrap: balance;
}

h1, h2, h3, h4, h5, h6, li, button, th {
  text-wrap: pretty;
}

h1, h2, h3, h4, h5, h6, p, li, button {
  &:first-letter {
    text-transform: uppercase;
  }
}

.Section {
  @container section-container (width < 367px) {
    .SectionInner {
      display: none;
    }
  }
  };

.text-center {
  text-align: center;
  margin-left: auto !important;
  margin-right: auto !important;
}


//https://carbucomstatic-5141.kxcdn.com/mazout_com
body {
  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: normal;
    src: local('Myriad Pro Regular'),
      url('/fonts/Lato-Regular.woff2') format('woff2'),
      url('/fonts/Lato-Regular.ttf') format('truetype');
    font-display: optional;
  }

  @font-face {
    font-family: 'Lato-Italic';
    font-style: italic;
    font-weight: normal;
    src: local('Myriad Pro Regular'),
      url('/fonts/Lato-Italic.woff2') format('woff2'),
      url('/fonts/Lato-Italic.ttf') format('truetype');
    font-display: swap;
  }

  @font-face {
    font-family: 'Lato-Bold';
    font-style: normal;
    font-weight: bold;
    src: local('Myriad Pro Regular'),
      url('/fonts/Lato-Bold.woff2') format('woff2'),
      url('/fonts/Lato-Bold.ttf') format('truetype');
    font-display: swap;
  }

  @font-face {
    font-family: 'Lato-BoldItalic';
    font-style: italic;
    font-weight: bold;
    src: local('Myriad Pro Regular'),
      url('/fonts/Lato-BoldItalic.woff2') format('woff2'),
      url('/fonts/Lato-BoldItalic.ttf') format('truetype');
    font-display: swap;
  }

  @font-face {
    font-family: 'Lato-Light';
    font-style: normal;
    font-weight: 300;
    src: local('Myriad Pro Regular'),
      url('/fonts/Lato-Light.woff2') format('woff2'),
      url('/fonts/Lato-Light.ttf') format('truetype');
    font-display: swap;
  }

  @font-face {
    font-family: 'Lato-LightItalic';
    font-style: italic;
    font-weight: 300;
    src: local('Myriad Pro Regular'),
      url('/fonts/Lato-LightItalic.woff2') format('woff2'),
      url('/fonts/Lato-LightItalic.ttf') format('truetype');
    font-display: swap;
  }

  @font-face {
    font-family: 'Lato-Black';
    font-style: normal;
    font-weight: 900;
    src: local('Myriad Pro Regular'),
      url('/fonts/Lato-Black.woff2') format('woff2'),
      url('/fonts/Lato-Black.ttf') format('truetype');
    font-display: swap;
  }

  @font-face {
    font-family: 'Lato-BlackItalic';
    font-style: italic;
    font-weight: 900;
    src: local('Myriad Pro Regular'),
      url('/fonts/Lato-BlackItalic.woff2') format('woff2'),
      url('/fonts/Lato-BlackItalic.ttf') format('truetype');
    font-display: swap;
  }

  @font-face {
    font-family: 'Lato-Thin';
    font-style: normal;
    font-weight: 100;
    src: local('Myriad Pro Regular'),
      url('/fonts/Lato-Thin.woff2') format('woff2'),
      url('/fonts/Lato-Thin.ttf') format('truetype');
    font-display: swap;
  }

  @font-face {
    font-family: 'Lato-ThinItalic';
    font-style: italic;
    font-weight: 100;
    src: local('Myriad Pro Regular'),
      url('/fonts/Lato-ThinItalic.woff2') format('woff2'),
      url('/fonts/Lato-ThinItalic.ttf') format('truetype');
    font-display: swap;
  }


  @font-face {
    font-family: 'MuseoSansRounded';
    font-style: normal;
    font-weight: normal;
    src: local('Myriad Pro Regular'),
      url('/fonts/MuseoSansRounded700.woff2') format('woff2');
    font-display: swap;
  }
  @font-face {
    font-family: 'MuseoSansRounded700';
    font-style: normal;
    font-weight: normal;
    src: local('Myriad Pro Regular'),
      url('/fonts/MuseoSansRounded700.woff2') format('woff2');
    font-display: swap;
  }

  @font-face {
    font-family: 'MuseoSansRounded900';
    src: local('Myriad Pro Regular'),
      url('/fonts/MuseoSansRounded900.woff2') format('woff2');
    font-display: swap;
  }

  @font-face {
    font-family: 'MuseoSansRounded-900';
    src: local('Myriad Pro Regular'),
      url('/fonts/MuseoSansRounded900.woff2') format('woff2');
    font-display: swap;
  }

}


.modal_portal:not(:empty) {
    position: fixed;
    inset: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.15);
  }

  .modal_content {
    position: fixed;
    z-index: 999;
    justify-content: center;
    align-items: center;
  }

  .modal_content.noWhiteBox {
    background-color: transparent;
  }
  .modal_content.offerCardPopup.noWhiteBox {
    @media screen and (min-width: 800px) {
      max-width: 60vw;
      max-height: 70vh;
      overflow-y: hidden;
      top: 0;
      left: 0;
      right: 0;
      padding: 0;
    }

    background-color: transparent;

    margin: auto;
    position: fixed;
    z-index: 10;
    border-radius: 4px;
    box-shadow: none;
    position: fixed;
    inset: 0px;
    .modal_close svg {
      color: white;
      fill: white;
    }
    > div {
      max-height: 100%;
      display: flex;
    }
  }

  .modal_content.center {
    max-width: 60vw;
    max-height: 60vh;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0;
    margin: auto;
  }
  .modal_content.right {
    background: white;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0;
    @media screen and (min-width: 860px) {
      max-width: 60%;
      top: 0;
      left: 60%;
      right: 0;
      bottom: 0;
      padding: 0;
    }
    overflow: auto;
  }

  /* Print styles */
  .print-only {
    display: none !important;
  }

  @media print {
    .print-only {
      display: block !important;
    }
    .no-print {
      display: none !important;
    }
    /* Force color printing for price section */
    .price-section {
      background-color: #4d4d4d !important;
      color: white !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    .price-section * {
      color: white !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
  }
`;

export default GlobalStyle;
